// import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
// import { Subscription } from 'rxjs';
// import { DocumentService } from '@app/shared/services';
//@Component({
//   selector: 'non-document-summary',
//   templateUrl: './non-document-summary.component.html',
//   styleUrl: './non-document-summary.component.scss',
//   changeDetection: ChangeDetectionStrategy.OnPush,
// })
// export class NonDocumentSummaryComponent implements OnInit, OnDestroy {
//   @Input() currentFormId;
//   @Input() currentuserId;
//   @Input() vault_id;
//   subscription = new Subscription();

//   enableTab = 'Explore with Ai';
//   isHovering = false;

//   summaryData;
//   brokenLinkSectionExpanded = false;
//   constructor(private documentService: DocumentService, private cd: ChangeDetectorRef) {}

//   handleMxDrawer() {
//     if (this.isHovering) {
//       this.brokenLinkSectionExpanded = !this.brokenLinkSectionExpanded;
//     }
//   }
//   ngOnInit(): void {
//     this.subscription.add(
//       this.documentService.getFormSummarySummaryData(this.currentFormId).subscribe((data) => {
//         this.summaryData = data.data.summary_data;
//         if (this.summaryData) {
//           this.isHovering = true;
//         }
//         this.cd.detectChanges();
//       })
//     );
//   }

//   ngOnDestroy(): void {
//     this.subscription?.unsubscribe();
//   }
// }

import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataExtractionService, DocumentService } from '@app/shared/services';
import { ChangeDetectorRef } from '@angular/core';
import { fetchAuthSession } from 'aws-amplify/auth';
import { environment } from '@env/environment';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'non-document-summary',
  templateUrl: './non-document-summary.component.html',
  styleUrls: ['./non-document-summary.component.scss'],
})
export class NonDocumentSummaryComponent implements OnInit, OnDestroy {
  @Input() currentFormId;
  @Input() currentuserId;
  @Input() vault_id;
  @Input() currentTemplate;
  @Input() linkDocuments;
  @Input() isComplexTemplateAi;
  @Input() documentName?: string;
  summaryData = '';
  ai_is_running = false;
  expandedPanel = false;
  isSummeryContent = false;
  subscription = new Subscription();
  view_summary = true;
  id;
  enableTab = 'Summary';
  isHovering = false;
  updatingSummary = false;

  // Worker reference for proper cleanup
  private checkAIWorker: Worker | undefined;

  constructor(private documentService: DocumentService, private _dataExtractionService: DataExtractionService, private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.view_summary = true;
    this.getSummaryData();
  }

  getSummaryData() {
    this.subscription.add(
      this.documentService.getFormSummaryData(this.currentFormId).subscribe((res) => {
        this.summaryData = res.data.summary_data;
        this.view_summary = res.data.viewed;
        this.id = res.data.id;
        this.isSummeryContent = this.summaryData ? true : false;
        this.cd.detectChanges();
      })
    );
  }
  updateSummaryData() {
    this.ai_is_running = true;
    this.updatingSummary = true;
    this.summaryData = '';
    this.subscription.add(
      this._dataExtractionService
        .dataExtractionManualTrigger({
          vault_user_form_id: this.currentFormId,
          execution_type: 'manual_summary_summary',
        })
        .subscribe(
          (res) => {
            this.checkSummaryIsCreatingFromAI();
          },
          (error) => {
            this.updatingSummary = false;
            this.cd.detectChanges();
          }
        )
    );
  }
  async checkSummaryIsCreatingFromAI() {
    this.ai_is_running = true;

    // Terminate previous worker if exists
    if (this.checkAIWorker) {
      this.checkAIWorker.terminate();
    }

    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        this.checkAIWorker = new Worker(new URL('./check-ai-status-upload-file.worker', import.meta.url), { type: 'module' });

        const data = {
          token: '',
          url: `${environment.apiUrl}/api/vault/check-upload-file-ai-running`,
          vault_user_form_id: this.currentFormId,
          execution_type: 'manual_summary_summary',
        };
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        this.checkAIWorker.onmessage = async ({ data }) => {
          if (data.data.ai_is_running) {
            setTimeout(() => {
              this.checkSummaryIsCreatingFromAI();
            }, 15000);
          } else {
            this.ai_is_running = false;
            this.getSummaryData();
            this.updatingSummary = false;
            this.cd.detectChanges();
          }
          resolve(data);
        };
        this.checkAIWorker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generatecreateFileAfterS3UrlCrete(null));
        this.updatingSummary = false;
        this.cd.detectChanges();
      }
    });
  }
  generatecreateFileAfterS3UrlCrete(data: any): unknown {
    throw new Error('Method not implemented.');
  }

  togglePanel() {
    if (this.expandedPanel && !this.view_summary) {
      this.view_summary = true;
      this.cd.detectChanges();
      this.updateVaultUserFormSummary();
    }
  }

  updateVaultUserFormSummary() {
    this.subscription.add(this.documentService.updateVaultUserFormSummary(this.id).subscribe(() => {}));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();

    // Terminate worker
    if (this.checkAIWorker) {
      this.checkAIWorker.terminate();
      this.checkAIWorker = undefined;
    }
  }
}
